import { createFileRoute } from '@tanstack/react-router';

import { WgTasksView } from 'src/sections/white-glove/tasks/tasks-view';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tasks')({
  component: WgTasksPage,
});

function WgTasksPage() {
  return <WgTasksView />;
}
